import React from "react"
import { useTranslation } from "react-i18next"
import { Dialog, DialogContent, Typography } from "@mui/material"
import { ReactComponent as CameraPermissionGraphic } from "../../icon/camera-permission.svg"
import BobbingIcon from "../common/BobbingIcon"

interface PermissionModalProps {
  show: boolean
}

function PermissionModal({ show }: PermissionModalProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={show}
      disableEscapeKeyDown
      slotProps={{ paper: { sx: { borderRadius: "0.7rem", color: "#323232", maxWidth: 480 } } }}
    >
      <DialogContent sx={{ p: 4, textAlign: "center" }}>
        <BobbingIcon
          horizontalOffset="-58px"
          verticalOffset="-30px"
        >
          <CameraPermissionGraphic />
        </BobbingIcon>
        <Typography fontSize={28} fontWeight={500}>{t("cameraPermission.heading")}</Typography>
        <Typography fontSize={18} fontWeight={400} sx={{mt:1}}>
          {t("cameraPermission.text")}
        </Typography>
      </DialogContent>
    </Dialog>
  )
}

export default PermissionModal
